import { useEffect, useState, useRef } from "react";
import { useInstantSearch, useSearchBox, type UseSearchBoxProps } from "react-instantsearch";
import {useConfigContext} from "../../ConfigProvider.tsx";
import { Panel } from "./Panel.tsx";
export function SearchBox(props: UseSearchBoxProps) {
	const { tc } = useConfigContext();
	const { query, refine } = useSearchBox(props);
	const { status } = useInstantSearch();
	const [inputValue, setInputValue] = useState(query);

	useEffect(() => {
		if (document.activeElement !== inputRef.current) {
			setInputValue(query);
		}
	}, [query]);

	const inputRef = useRef(null);
	const isSearchStalled = status === "stalled";
	function setQuery(newQuery: string) {
		setInputValue(newQuery);
		refine(newQuery);
	}
	return (
		<Panel title={"SUCHE"}>
			<div className="ais-searchBox">
				<form
					action=""
					role="search"
					noValidate
					className="ais-searchBox__form"
					onSubmit={(event) => {
						event.preventDefault();
						event.stopPropagation();
						if (inputRef.current) {
							(inputRef.current as HTMLElement).blur();
						}
						const q = inputValue.trim();
						if (q.length > 0) {
							window.location.href = `/de/search/?input_search=${encodeURIComponent(q)}`;
						}
					}}

					onReset={(event) => {
						event.preventDefault();
						event.stopPropagation();
						setQuery("");
						if (inputRef.current) {
							(inputRef.current as HTMLElement).focus();
						}
					}}
				>
					<button type="submit" className={"ais-searchBox__submit"} title={tc.search}>
						<i className="iconNew iconNew-search" aria-hidden={true}></i>
					</button>
					<input
						ref={inputRef}
						autoComplete="off"
						autoCorrect="off"
						autoCapitalize="off"
						placeholder={tc.search}
						spellCheck={false}
						maxLength={512}
						id={"searchBox"}
						className={"ais-searchBox__input"}
						type="search"
						value={inputValue}
						onChange={(event) => {
							setQuery(event.currentTarget.value);
						}}
						autoFocus
					/>
					<button
						type="reset"
						hidden={inputValue.length === 0 || isSearchStalled}
						aria-hidden={inputValue.length === 0 || isSearchStalled}
						title={tc.resetFilters}
						className={"ais-searchBox__reset"}
					>
						<i className="icon icon-close" aria-hidden={true}></i>
					</button>
				</form>
			</div>
		</Panel>
	);
}
